import React, { useState, useCallback, useEffect } from "react";
import {
  Page,
  Layout,
  FormLayout,
  Card,
  Button,
  PageActions,
  Toast,
  Spinner,
  Loading,
} from "@shopify/polaris";
import axios from "../Assets/Lib/axios";
import { useNavigate } from "react-router-dom";
import { accessSettings } from "../Helpers";
import AppSettingsListItem from "../Components/AppSettingsListItem";

const AppSettings = () => {
  const [isSaving, setIsSaving] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const loadingMarkup = isLoading ? <Loading /> : null;
  const [settingsList, setSettingsList] = useState([
    {
      key: "",
      value: "",
    },
  ]);

  const handleUpdateItem = (value, field, itemIndex) => {
    setSettingsList((current) =>
      current.map((obj, index) => {
        if (index === itemIndex) {
          return field === "key"
            ? { ...obj, key: value }
            : { ...obj, value: value };
        }

        return obj;
      })
    );
  };
  const handleRemoveItem = (indexItem) => {
    const newList = settingsList.filter((item, index) => index !== indexItem);
    setSettingsList(newList);
  };
  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const toastMarkup = active ? (
    <Toast
      content="Changes have been saved successfully"
      onDismiss={toggleActive}
    />
  ) : null;
  useEffect(() => {
    axios
      .get(`/settings/app-settings`)
      .then((result) => {
        setSettingsList(
          result.data.data.map((item, index) => {
            return {
              key: item.key,
              value: item.value.text,
            };
          })
        );

        setIsLoading(false);
      })
      .catch((err) => console.log(err));
  }, []);

  return (
    accessSettings() && (
      <Page title="App Settings" narrowWidth>
        {loadingMarkup}

        <Card sectioned>
          {isLoading ? (
            <div className="spinnerContainer">
              <div className="vertical-center">
                <Spinner size="large" />
              </div>
            </div>
          ) : (
            <FormLayout>
              {settingsList.map((element, index) => {
                return (
                  <AppSettingsListItem
                    key={index}
                    keyField={element.key}
                    value={element.value}
                    handleUpdateItem={handleUpdateItem}
                    handleRemoveItem={handleRemoveItem}
                    id={index}
                  />
                );
              })}
              <Button
                primary
                fullWidth
                onClick={() => {
                  const newList = settingsList.concat({
                    key: "",
                    value: "",
                  });
                  setSettingsList(newList);
                }}
              >
                Add Item
              </Button>
            </FormLayout>
          )}
        </Card>
        <PageActions
          primaryAction={{
            content: "Save",
            onClick: handleSave,
            loading: isSaving && true,
          }}
        />
        {toastMarkup}
      </Page>
    )
  );
  function handleSave() {
    setIsSaving(true);
    const bodyObj = {
      app_settings: settingsList.map((item, index) => {
        return {
          key: item.key,
          value: { text: item.value },
        };
      }),
    };

    axios
      .patch(`/settings/app-settings`, bodyObj)
      .then((res) => {
        setIsSaving(false);
        toggleActive();
      })
      .catch((err) => console.log(""));
  }
};

export default AppSettings;
